

var productList = [
  {
    title: 'TRUFFLE BACKPACK 2',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">TRUFFLE&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">BACKPACK 2</div>'
  },
  {
    title: 'TRUFFLE BACKPACK',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">TRUFFLE&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">BACKPACK</div>'
  },
  {
    title: 'PORCINI TOTE',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">PORCINI&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">TOTE</div>'
  },
  {
    title: 'PORCINI BACKPACK',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">PORCINI&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">BACKPACK</div>'
  },
  {
    title: 'PISTACHIO 2 STRIPED 2025SS LIMITED EDITION',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">PISTACHIO 2&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">STRIPED TRUNK</div>'
  },
  {
    title: 'PISTACHIO 2 STRIPED TRUNK',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">PISTACHIO 2&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">STRIPED TRUNK</div>'
  },
  {
    title: 'PISTACHIO 2 STRIPED',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">PISTACHIO 2&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">STRIPED</div>'
  },
  {
    title: 'PISTACHIO STRIPED TRUNK',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">PISTACHIO&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">STRIPED TRUNK</div>'
  },
  {
    title: 'PISTACHIO STRIPED',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">PISTACHIO&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">STRIPED</text>'
  },
  {
    title: 'GINKGO 3 STRIPED',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">GINKGO 3&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">STRIPED</div>'
  },
  {
    title: 'GINKGO WEEKEND',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">GINKGO&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">WEEKEND</div>'
  },
  {
    title: 'TRUFFLE TRAVEL BACKPACK',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">TRUFFLE TRAVEL&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">BACKPACK</div>'
  },
  {
    title: 'PISTACHIO BACKPACK',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">PISTACHIO&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">BACKPACK</div>'
  },
  {
    title: 'CHANTERELLE DUFFLE BAG 2',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">CHANTERELLE&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">DUFFLE BAG 2</div>'
  },
  {
    title: 'CHANTERELLE DUFFLE',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">CHANTERELLE&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">DUFFLE</div>'
  },
  {
    title: 'AMANITA CROSSBODYBAG 2',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">AMANITA&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">CROSSBODYBAG 2</div>'
  },
  {
    title: 'LUGGAGE COVER PISTACHIO',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">LUGGAGE COVER PISTACHIO&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;"></div>'
  },
  {
    title: 'PISTACHIO GLASSESCASE',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">PISTACHIO&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">GLASSESCASE</div>'
  },
  {
    title: 'GINKGO 3 STRIPED COMBO',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">GINKGO 3&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">STRIPED</text><text>&nbsp;COMBO</div>'
  },
  {
    title: 'ORGANIZER JEWELRY BAG',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">ORGANIZER&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">JEWELRY BAG</div>'
  },
  {
    title: 'ORGANIZER BENTO SYSTEM',
    h5: '<text style="font-weight:600;letter-spacing: .5px;">ORGANIZER&nbsp;</text><div style="letter-spacing: .5px;font-weight: 300;transform-origin: left;display: inline-flex;">BENTO SYSTEM</div>'
  },
]
// 适用于入参包含产品尺寸的情况，如product-item中的产品名称
function showCustomerizeName(prodTitle) {
  var index = productList.findIndex(prod=> prodTitle.startsWith(prod.title))
  if(index >=0){
    if(prodTitle == productList[index].title){
      return productList[index].h5
    }else{
      let size = prodTitle.split(productList[index].title)[1]
      return productList[index].h5 + '<text style="color:rgba(166, 166, 166, 1);font-weight:500;position: relative;">&nbsp;'+size+'</text>'
    }
  }else{
    return prodTitle
  }
}

// 入参为一整段字符，在字符串中寻找品名，替换为标准写法，不识别产品尺寸
function replaceCustomerizeName(paragraph){
  for (let i = 0; i < productList.length; i++) {
    var idx = paragraph.indexOf(productList[i].title)
    if(idx >= 0)
      paragraph = paragraph.replaceAll(productList[i].title,productList[i].h5)
  }
  return paragraph
}